


const Url = ({ attributes, reverseString, enCode, clickOpenTab }) => {

    const { content } = attributes;
    const revUrl = reverseString(content?.url);

    return <a href={`${enCode}`} target='__blank' onClick={() => { event.preventDefault(); clickOpenTab(content); }}>{revUrl}<div id='innerContainer'></div></a>
}
export default Url;